import { Link } from 'react-router-dom'
import { FaTruck, FaPhone, FaEnvelope, FaWeixin } from 'react-icons/fa'
// 注释保留，不是删除：地址块与微博/Facebook/Twitter 三个社交链接在下方是注释状态
// （见 contactAddress 与 socialWeibo/socialFacebook/socialTwitter 那两段），
// 放开那些 JSX 时把对应图标从这里加回去：
// import { FaMapMarkerAlt, FaFacebook, FaTwitter, FaWeibo } from 'react-icons/fa'
import { siteConfig } from '../../config/site'
// 栏目与链接来自站点结构的唯一来源；此前这里是手工同步的第二份拷贝
// （旧注释写着「顺序与 Navbar 的集运板块保持一致」，靠人记着同步）。
import { getFooterSections } from '../../config/navigation'


export default function Footer() {
  const currentYear = new Date().getFullYear()
  const footerSections = getFooterSections()

  return (
    <footer className="bg-gradient-to-b from-gray-50 to-white border-t border-gray-200">
      {/* 垂直距离只由这一处 padding 决定，原先额外叠的两个 h-8 空块已删 */}
      <div className="container pt-8 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 sm:gap-12 lg:gap-8">
          {/* Brand Section - 5 columns */}
          <div className="lg:col-span-5">
            <Link to="/" className="inline-flex items-center gap-3 text-primary-700 text-2xl font-bold mb-4 sm:mb-5 hover:text-primary-600 transition-colors">
              <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-700 rounded-xl flex items-center justify-center">
                <FaTruck className="text-white text-lg" />
              </div>
              <span>{siteConfig.siteName}</span>
            </Link>
            <p className="text-fluid-sm sm:text-base text-gray-500 leading-relaxed mb-5 sm:mb-6 max-w-md">
              {siteConfig.siteDescription}，为您提供高效、透明、可追溯的全链路物流解决方案。
            </p>

            {/* Contact Info */}
            <div className="space-y-2.5 sm:space-y-3 mb-5 sm:mb-6">
              <a href={`tel:${siteConfig.contactPhone}`} className="flex items-center gap-3 text-gray-600 hover:text-primary-600 transition-colors">
                <div className="w-8 h-8 bg-primary-50 rounded-lg flex items-center justify-center">
                  <FaPhone className="text-primary-600 text-sm" />
                </div>
                <span className="font-medium">{siteConfig.contactPhone}</span>
              </a>
              <a href={`mailto:${siteConfig.contactEmail}`} className="flex items-center gap-3 text-gray-600 hover:text-primary-600 transition-colors">
                <div className="w-8 h-8 bg-primary-50 rounded-lg flex items-center justify-center">
                  <FaEnvelope className="text-primary-600 text-sm" />
                </div>
                <span>{siteConfig.contactEmail}</span>
              </a>
              {/* <div className="flex items-start gap-3 text-gray-500">
                <div className="w-8 h-8 bg-primary-50 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FaMapMarkerAlt className="text-primary-600 text-sm" />
                </div>
                <span className="text-sm leading-relaxed">{siteConfig.contactAddress}</span>
              </div> */}
            </div>

            {/* Social Links */}
            <div className="flex items-center gap-2">
              {siteConfig.socialWechat && (
                <a href={siteConfig.socialWechat} className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-500 rounded-xl hover:bg-green-500 hover:text-white transition-all duration-300">
                  <FaWeixin className="text-lg" />
                </a>
              )}
              {/* {siteConfig.socialWeibo && (
                <a href={siteConfig.socialWeibo} className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-500 rounded-xl hover:bg-red-500 hover:text-white transition-all duration-300">
                  <FaWeibo className="text-lg" />
                </a>
              )}
              {siteConfig.socialFacebook && (
                <a href={siteConfig.socialFacebook} className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-500 rounded-xl hover:bg-blue-600 hover:text-white transition-all duration-300">
                  <FaFacebook className="text-lg" />
                </a>
              )}
              {siteConfig.socialTwitter && (
                <a href={siteConfig.socialTwitter} className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-500 rounded-xl hover:bg-sky-500 hover:text-white transition-all duration-300">
                  <FaTwitter className="text-lg" />
                </a>
              )} */}
            </div>
          </div>

          {/* Links Sections - 7 columns（「散货拼柜」栏目在 config/navigation.js 里注释保留） */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-fluid-xs gap-6 sm:gap-8">
            {footerSections.map((section) => (
              <div key={section.title}>
                <h5 className="text-gray-900 font-bold mb-3 sm:mb-5 text-base">{section.title}</h5>

                {/* 小屏 chip 流式：竖排在窄屏一列 53% 是空白；chip 的内距同时把触控区撑到 37px */}
                <ul className="flex flex-wrap gap-2 sm:hidden">
                  {section.links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="inline-flex items-center rounded-lg border border-gray-200 bg-white px-3 py-2 text-fluid-sm text-gray-600 active:bg-gray-50"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>

                <ul className="hidden sm:block space-y-3">
                  {section.links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-gray-500 hover:text-primary-600 transition-colors inline-flex items-center gap-2 group"
                      >
                        <span className="w-1.5 h-1.5 bg-gray-300 rounded-full group-hover:bg-primary-500 transition-colors" />
                        <span>{link.label}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200 bg-white">
        {/* 不加垂直内距：版权行就贴着分隔线，高度只由行高决定 */}
        <div className="container flex flex-col md:flex-row justify-between items-center gap-1.5 leading-relaxed">
          <p className="text-gray-500 text-fluid-sm text-center md:text-left">
            © {currentYear} {siteConfig.companyName}. 保留所有权利
            {siteConfig.companyIcp && (
              <>
                <br className="md:hidden" />
                <span className="hidden md:inline ml-3 text-gray-400">|</span>
                <span className="md:ml-3 text-gray-400">{siteConfig.companyIcp}</span>
              </>
            )}
          </p>
          <p className="text-gray-400 text-fluid-sm text-center md:text-right">
            由 <span className="text-primary-600 font-medium">{siteConfig.siteName}</span> 提供技术支持
          </p>
        </div>
      </div>
      {/* 小屏底部留白：删干净后版权行会贴到屏幕底边；同时避让 iOS 安全区 */}
      <div
        className="h-8 md:h-0 bg-white"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      />
    </footer>
  )
}
